import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Bill_item_input } from '../models/accounting/bill_item_input';
import { Statement } from '../models/accounting/statement';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class AccountItemsService {

  constructor(private http: HttpClient) { }

	public getBillItemInputListForEntryTypeAtHorseShow(horse_show_id: string, entry_type_number: number): Promise<Bill_item_input[]> {
  		return this.getBillItemInputListWithRESTUrlFilter('horse_show_id/' + horse_show_id + '/entry_type_number/' + entry_type_number);
  	}

    public getBillItemInputListForHorseShowEntryHavingType(horse_show_id: string, entry_id: string, entry_type_number: number): Promise<Bill_item_input[]> {
      return this.getBillItemInputListWithRESTUrlFilter('horse_show_id/' + horse_show_id + '/entry_id/' + entry_id + '/entry_type_number/' + entry_type_number);
    }

   public getBillItemInputListForHorseShowEntryHavingMultipleTypes(horse_show_id: string, entry_id: string): Promise<Bill_item_input[]> {
     return this.getBillItemInputListWithRESTUrlFilter('horse_show_id/' + horse_show_id + '/entry_id/' + entry_id + '/search_all_types_for_entry/true');
   }

	private getBillItemInputListWithRESTUrlFilter(rest_url: string) : Promise<Bill_item_input[]> {
  	return new Promise((resolve, reject) => {
		return this.http.get(AppSettings.API_ENDPOINT + 'accounting/account_items/bill_item_inputs/true/' + rest_url).subscribe((response:any) => {
			if(response.type == 'bill_item_inputs' && response.data){
				resolve(response.data);
			} else {
				reject(response);
			}

		},
			error => {
	      		if(error instanceof HttpErrorResponse){
            	  reject(error.error);
            	} else {
            		reject(error);
            	}
			});
	});
  }

  public saveBillingItems(entry_id: string, bill_item_inputs: Bill_item_input[]): Promise<Statement> {

  	let post_data = {
          data: {
            type: 'account_items',
            attributes: bill_item_inputs
            }
        };

  	return new Promise((resolve, reject) => {
      return this.http.post(AppSettings.API_ENDPOINT + 'accounting/account_items/bill_item_inputs/true/entry_id/' + entry_id,
        post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
          if(response.data && response.type=='statement') {
               resolve(response.data);
               }  else {
                 reject(response);
               }

        }, error => {
          if(error instanceof HttpErrorResponse){
        	  reject(error.error);
        	} else {
        		reject(error);
        	}
        });
    });
	}

}
